import axios from 'axios'
import toastr from '@/lib/notifications'
import store from '../state/store'

store.on('coachbit_order:place', function(enquiry_id, params) {
  axios.put(`/api/sales/enquiries/${enquiry_id}/coachbit_orders/place`, params)
    .then(function(response) {
      toastr.success('Coachbit Order placed.')
      store.emit('enquiry:learners:index', enquiry_id)
      store.emit('orders:index', enquiry_id)
    })
    .catch(function(error) {
      const message = (error && error.response && error.response.data && error.response.data.custom_error_message) || 'Failed to place Coachbit Order.'
      toastr.error(message)
    })
})

store.on('coachbit_order:activate', function(enquiry_id, params) {
  axios.put(`/api/sales/enquiries/${enquiry_id}/coachbit_orders/activate`, params)
    .then(function(response) {
      toastr.success('Coachbit trial activated.')
      store.emit('enquiry:learners:index', enquiry_id)
      store.emit('orders:index', enquiry_id)
    })
    .catch(function(error) {
      const message = (error && error.response && error.response.data && error.response.data.custom_error_message) || 'Failed to activate Coachbit trial.'
      toastr.error(message)
    })
})

store.on('coachbit_order:add_to_order', function(enquiry_id, params) {
  axios.put(`/api/sales/enquiries/${enquiry_id}/coachbit_orders/add_to_order`, params)
    .then(function(response) {
      toastr.success('Coachbit Order added to order.')
      store.emit('enquiry:learners:index', enquiry_id)
      store.emit('orders:index', enquiry_id)
    })
    .catch(function(error) {
      const message = (error && error.response && error.response.data && error.response.data.custom_error_message) || 'Failed to add Coachbit Order to order.'
      toastr.error(message)
    })
})

store.on('coachbit_order:update', function(enquiry_id, order_id, params) {
  axios.put(`/api/sales/enquiries/${enquiry_id}/coachbit_orders/${order_id}`, params)
    .then(function(response) {
      toastr.success('Coachbit Order updated.')
      store.emit('enquiry:learners:index', enquiry_id)
      store.emit('orders:index', enquiry_id)
    })
    .catch(function(error) {
      const message = (error && error.response && error.response.data && error.response.data.custom_error_message) || 'Failed to update Coachbit Order.'
      toastr.error(message)
    })
})

store.on('coachbit_order:cancel', function(enquiry_id, order_id) {
  axios.put(`/api/sales/enquiries/${enquiry_id}/coachbit_orders/${order_id}/cancel`)
    .then(function(response) {
      toastr.success('Coachbit Order cancelled.')
      store.emit('enquiry:learners:index', enquiry_id)
      store.emit('orders:index', enquiry_id)
    })
    .catch(function(error) {
      const message = (error && error.response && error.response.data && error.response.data.custom_error_message) || 'Failed to cancel Coachbit Order.'
      toastr.error(message)
    })
})
